module.exports = __webpack_public_path__ + "img/telemedicine2.d25ec6c4.webp";